import { render } from "./ImportacionProductosView.vue?vue&type=template&id=35a1b888&scoped=true"
import script from "./ImportacionProductosView.vue?vue&type=script&lang=js"
export * from "./ImportacionProductosView.vue?vue&type=script&lang=js"

import "./ImportacionProductosView.vue?vue&type=style&index=0&id=35a1b888&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a1b888"]])

export default __exports__